export default "__VITE_ASSET__Cak9XdnJ__"